const HVUser = {
    id: 1,
    first_name: 'Healthvana',
    last_name: 'System',
    birthdate: '01/01/80',
    preferred_name: 'Healthvana',
    full_name: 'Healthvana System',
    initials: 'HV'
};

export default HVUser;
